import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.scss'],
})
export class AccountNavComponent implements OnInit {
  screenType = ScreenType;
  populations = Populations;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  isActive(url: string): boolean {
    // Check if the route contains query params.
    const hasQueryParams = Object.keys(this.route.snapshot.queryParams)?.length > 0;
    return this.router.isActive(url, true) || (this.router.isActive(url, false) && hasQueryParams);
  }
}
